"use client"

import { CardService } from "@/(admin)/modules/ui-builder/config/blocks/CardService"
import { TeamMember } from "@/(admin)/modules/ui-builder/config/blocks/TeamMember"
import { DansFooter } from "@/(admin)/modules/ui-builder/config/components/Footer"
import BikeRentalTable from "@/(admin)/modules/ui-builder/config/themes/caocao/BikeRentalTable"
import { CaoCaoCustomizeTour } from "@/(admin)/modules/ui-builder/config/themes/caocao/CaoCaoCustomizeTour"
import { CaoCaoFAQs } from "@/(admin)/modules/ui-builder/config/themes/caocao/CaoCaoFAQs"
import { CycList } from "@/(admin)/modules/ui-builder/config/themes/caocao/CycList/TourTypesGrid"
import { Config } from "@measured/puck"
import { AutoSlider as AutoSliderConfig } from "./blocks/AutoSlider"
import { Box } from "./blocks/Box"
import { Button } from "./blocks/Button"
import { ButtonDans } from "./blocks/Button Dans"
import { Columns } from "./blocks/Columns"
import { Container } from "./blocks/Container"
import { EmailSubscription } from "./blocks/EmailSubscription"
import { Heading } from "./blocks/Heading"
import { Image as ImageConfig } from "./blocks/Image"
import { ImageCard } from "./blocks/ImageCard"
import { MapDisplay } from "./blocks/MapDisplay"
import { PhotoLibrary } from "./blocks/PhotoLibrary"
import { PostGrid as PostGridConfig } from "./blocks/PostGrid"
import { PostGridByCategory as PostGridByCategoryConfig } from "./blocks/PostGridByCategory"
import { ProfileUserCard } from "./blocks/ProfileUserCard"
import { SimpleSlider as SimpleSliderConfig } from "./blocks/SimpleSliders"
import { CustomTabs } from "./blocks/Tabs"
import { Text } from "./blocks/Text"
import { VericalSpace } from "./blocks/VerticalSpace"
import { Video as VideoConfig } from "./blocks/Video"
import { VideoLibrary } from "./blocks/VideoLibrary"
import { ArticlesItemsList } from "./themes/caocao/ArticlesItemsList/ArticlesItemsList"
import { BannerImage } from "./themes/caocao/BannerImage/BannerImage"
import { CaoCaoButton } from "./themes/caocao/CaoCaoButton/CaoCaoButton"
import { CaoCaoCarousel } from "./themes/caocao/CaoCaoCarousel/CaoCaoCarousel"
import { CaoCaoContact } from "./themes/caocao/CaoCaoContact/CaoCaoContact"
import { CaoCaoFeedback } from "./themes/caocao/CaoCaoFeedback/CaoCaoFeedback"
import { CaoCaoFooter } from "./themes/caocao/CaoCaoFooter/CaoCaoFooter"
import { CCACustomMedia } from "./themes/caocao/CaoCaoMedia/CustomMedia"
import { CaoCaoNavigation } from "./themes/caocao/CaoCaoNavigation/CaoCaoNavigation"
import { CaoCaoSlider } from "./themes/caocao/CaoCaoSlider/CaoCaoSlider"
import { CustomTours } from "./themes/caocao/CustomTours/CustomTours"
import { CCACardProfile } from "./themes/caocao/EnrollmentCard/CCACardProfile"
import { CCAFormCustomizeTour } from "./themes/caocao/FormCustomizeTour"
import { GridTours } from "./themes/caocao/GridTours/CustomTours"
import { LocationMap } from "./themes/caocao/LocationMap/LocationMap"
import { ModalEntrance } from "./themes/caocao/ModalEntrance/ModalEntrance"
import { SinglePost } from "./themes/caocao/SinglePost/SinglePost"
import { ToursCarousel } from "./themes/caocao/ToursCarousel/ToursCarousel"
import { WhyChooseUs } from "./themes/caocao/WhyChooseUs/WhyChooseUs"
// Components
// Below components config is used for renderer only

const uiBuilderComponents = {
  //layout
  Container,
  Columns,
  Box,
  VericalSpace,

  //content
  Heading,
  Text,
  Button,
  ProfileUserCard,
  EmailSubscription,
  MapDisplay,

  //media
  ImageCard,
  PhotoLibrary,
  VideoLibrary,
  VideoConfig,
  ImageConfig,

  //Loop data
  SimpleSliderConfig,
  PostGridByCategoryConfig,
  PostGridConfig,
  CustomTabs,

  //components
  DansFooter,
  //Dansolutions
  CardService,
  AutoSliderConfig,
  ButtonDans,
  TeamMember,

  //Cao Cao Adventure
  CaoCaoButton,
  CaoCaoCarousel,
  CaoCaoFeedback,
  CaoCaoFooter,
  CaoCaoNavigation,
  CaoCaoSlider,
  CustomTours,
  ToursCarousel,
  CaoCaoContact,
  LocationMap,
  ArticlesItemsList,
  GridTours,
  CCACardProfile,
  SinglePost,
  CCAFormCustomizeTour,
  CCACustomMedia,
  BannerImage,
  ModalEntrance,
  CycList,
  WhyChooseUs,
  BikeRentalTable,
  CaoCaoFAQs,
  CaoCaoCustomizeTour,
}

// primary config
export const configUi = {
  categories: {
    layout: {
      title: "Layout",
      components: ["Container", "Columns", "Box", "VericalSpace"],
    },
    content: {
      title: "Content",
      components: ["Heading", "Text", "Button", "ProfileUserCard"],
    },
    media: {
      title: "Media",
      components: ["ImageConfig", "ImageCard", "VideoConfig", "PhotoLibrary", "VideoLibrary"],
    },
    data: {
      title: "Data",
      components: ["SimpleSliderConfig", "PostGridByCategoryConfig", "PostGridConfig", "CustomTabs"],
    },
    dansolutions: {
      title: "Dansolutions",
      components: [
        "CardService",
        "AutoSliderConfig",
        "ButtonDans",
        "DansFooter",
        "ProductGrid",
        "TeamMember",
        "ProductGridByCategory",
        "EmailSubscription",
        "MapDisplay",
      ],
    },
    CAOCAO: {
      title: "Cao Cao Adventure",
      components: [
        "CaoCaoButton",
        "CaoCaoCarousel",
        "CaoCaoFeedback",
        "CaoCaoFooter",
        "CaoCaoNavigation",
        "CaoCaoSlider",
        "CustomTours",
        "CaoCaoContact",
        "LocationMap",
        "ArticlesItemsList",
        "GridTours",
        "CCACardProfile",
        "SinglePost",
        "CCAFormCustomizeTour",
        "CCACustomMedia",
        "BannerImage",
        "ModalEntrance",
        "CycList",
        "WhyChooseUs",
        "BikeRentalTable",
        "ToursCarousel",
        "CaoCaoFAQs",
        "CaoCaoCustomizeTour",
      ],
    },
  },

  root: {
    fields: {
      title: {
        type: "text",
        label: "Title",
      },
      breadcrumb: {
        type: "array",
        label: "Bread Crumb",
        min: 0,
        max: 4,
        arrayFields: {
          title: {
            type: "text",
            label: "Title",
          },
          link: {
            type: "text",
            label: "Link",
          },
        },
      },
    },
  },
}

// @ts-ignore
export const uiBuilderConfig: Config = {
  components: {
    //default components
    ...uiBuilderComponents,

    // Theme components
  },
  ...configUi,
}
